var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thumbnail)?_c('img',{staticClass:"file-thumbnail",attrs:{"src":_vm.thumbnail,"alt":"thumbnail","data-id":_vm.item.id}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.createSkeletonThumbnail)}})}
var staticRenderFns = []

export { render, staticRenderFns }